import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from "src/app/services/customer.service";
import { VendorService } from "src/app/services/vendor.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { EditViewDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/delete-view.component";
import { Utilities } from "src/app/models/utilities";
import { RateBandsService } from "src/app/services/ratebands.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { saveAs } from 'file-saver-es';
import { HttpHeaders } from "@angular/common/http";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AppCoreService } from "src/app/services/app-core.service";
import { TATService } from "src/app/services/system-config/tat/tat.service";
import { EditDeleteActionsRenderer } from "../../shared/ag-grid/cell-renderers/edit-delete.component";
import { TATPeriodComponent } from "./periods/tatperiod.component";
import { TATDetailsComponent } from "./details/tatdetails.component";
import { ExcelService } from "src/app/services/excel.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-upload',
  templateUrl: './tat.component.html',
  styleUrls: ['./tat.component.scss']
})

export class TATComponent implements OnInit, AfterViewInit {
  tatForm!: FormGroup;
  isFormSubmitted: boolean;
  showPeriodModal: boolean;
  showChargeModal: boolean;
  showSlabsModal: boolean;
  tatTypeList = [];
  contractTypeList = [];
  chargeBandList: []
  vendorList: any[] = [];
  customerList: any[] = [];
  // originList: any;
  // destinationList: any;
  // chargeCategoryCode: any;
  periodData: any;
  detailData: any;
  showDownloadBtn = false;
  showBands = false;
  showCustomer = false;
  showVendor = false;
  selectedFile: File | null = null;
  isContarctTypeMand = false;
  showContract = false;

  showProgressBar = false;
  progress: number = 0;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  tatId: number = null;
  mappingId: number;

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }
  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowDataTAT: any[] = [];
  rowDataTATInfo = [];
  columnDefsPeriod = [
    { headerName: 'TAT Type', field: 'tattype' },
    { headerName: 'Contract Type', field: 'tatcontracttype' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Customer', field: 'customername' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];
  columnDefs = [
    { headerName: 'Product', field: 'productname' },
    { headerName: 'Vendor', field: 'vendorname' },
    { headerName: 'Origin Country', field: 'origincountryname' },
    { headerName: 'Origin State', field: 'originstatename' },
    { headerName: 'Origin City', field: 'origincityname' },
    { headerName: 'Destination Country', field: 'destinationcountryname' },
    { headerName: 'Destination State', field: 'destinationstatename' },
    { headerName: 'Destination City', field: 'destinationcityname' },
    { headerName: 'Fixed Time', field: 'fixedtime' },
    { headerName: 'Days', field: 'days' },
    { headerName: 'Hours', field: 'hours' },
    {
      headerName: 'Actions',
      field: 'id',
      //cellRenderer: EditDeleteActionsRenderer,
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 100,
    },
  ];
  currentDate: any;
  selectedSCId: any;
  useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private chargeService: ChargesService,
    private chargeBandsService: RateBandsService,
    private fileHandlerService: FileHandlerService,
    private appCoreService: AppCoreService,
    public modalService: NgbModal,
    private tatService: TATService,
    private excelService: ExcelService,
    private titleService: Title
  ) {
    titleService.setTitle('TAT');
    this.context = {
      componentParent: this,
      componentName: 'TATComponent',
      actionConfig: { edit: true, delete: true, view: true }
    };
  }

  ngOnInit(): void {
    // set full width for this page 
    const bodyTag = document.body;
    bodyTag.classList.add('sidebar-enable')
    bodyTag.classList.add('vertical-collpsed');

    this.currentDate = this.utilities.FormatDateWithTime();
    this.tatForm = this.formBuilder.group({
      ddlTatType: [null, Validators.required],
      ddlContractType: [{ disabled: true, value: null }, Validators.required],
      ddlCustomer: [null, Validators.required],

      txtFromDate: [this.currentDate.dateString, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],
      fileControl: [null, Validators.required],
    });
    this.appCoreService.SelectedServiceCenter().subscribe(val => {
      this.selectedSCId = val;
      this.getAllTAT();
      this.getAllCustomers();
    })
    this.getAllTATTypes();

    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.checkPermission();
  };

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData(); 
    const permission = userData.config.filter(x => x.categoryname === 'TAT');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.tatForm) : null;
  }

  getAllTATTypes() {
    this.tatService.GetAllTypes().subscribe(res => {
      try {
        if (res && res.success) {
          this.tatTypeList = res.data.types.filter(type => type.tattype === 'Tariff' || type.tattype === 'Contract');
          this.contractTypeList = res.data.categories.filter(category => category.tatcategory === 'Customer');
        }
      } catch (error) {
        console.error(error);
      }
    })
  }



  openPeriodModel(data: any) {
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(TATPeriodComponent, this.ngbModalOptions);
    modalRef.componentInstance.periodData = data;
    modalRef.componentInstance.tatTypes = this.tatTypeList;
    modalRef.componentInstance.selectedSCId = this.selectedSCId;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.getAllTAT();
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
    this.ngxLoaderService.stop();
  }

  openDetailModel(data: any) {
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(TATDetailsComponent, this.ngbModalOptions);
    modalRef.componentInstance.detailData = data;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.bindTATInfoByTATId(this.tatId);
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
    this.ngxLoaderService.stop();
  }

  // getAllChargeTypes() {
  //   this.chargeService.GetAllTypes().subscribe(res => {
  //     try {
  //       if (res && res.success) {
  //         this.tatTypeList = res.data.types;
  //         this.contractTypeList = res.data.categories;
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   })
  // }

  getAllChargeBands() {
    try {
      this.chargeBandsService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.chargeBandList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res) {
          this.customerList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }

  }

  getAllVendors() {
    try {
      this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllTAT() {
    this.ngxLoaderService.start();
    this.tatService.GetAllTAT({ scid: this.selectedSCId }).subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataTAT = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })
  }


  bindTATInfoByTATId(tatId: number) {
    this.ngxLoaderService.start();
    this.tatService.GetTATInfoByTATId({ tatid: tatId, scid: this.selectedSCId }).subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataTATInfo = res.data;
          // console.log(res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })
  }

  onChangeTatType() {
    const tatControl = this.tatTypeList.find(x => x.id === this.tatForm.controls.ddlTatType.value);
    if (tatControl?.tattype === 'Tariff') {
      // Tariff
      this.isContarctTypeMand = false;
      this.showDownloadBtn = true;
      this.showCustomer = false;
      this.showContract = false;

      this.tatForm.controls.ddlCustomer.clearValidators();
      this.tatForm.controls.ddlContractType.clearValidators();
      this.tatForm.controls.ddlContractType.reset();
      this.tatForm.controls.ddlContractType.disable();
      this.tatForm.controls.ddlCustomer.reset();
      this.isFormSubmitted = false;
    } else if (tatControl?.tattype === 'Contract') {
      // Contract
      this.showContract = true;
      this.showDownloadBtn = true;
      this.tatForm.controls.ddlContractType.enable();
      this.isContarctTypeMand = true;
      this.showCustomer = true;
      this.tatForm.controls.ddlContractType.enable();
      this.tatForm.controls.ddlContractType.setValidators([Validators.required]);
      this.tatForm.controls.ddlCustomer.setValidators([Validators.required]);
      this.isFormSubmitted = false;
    } else {
      this.showDownloadBtn = false;
      this.showCustomer = false;
      this.showContract == false;
    }
    this.tatForm.controls.ddlContractType.updateValueAndValidity();
    this.tatForm.controls.ddlCustomer.updateValueAndValidity();
  }

  onChangeContractType() {
    if (this.contractTypeList.find(x => x.id === this.tatForm.controls.ddlContractType.value)?.tatcategory === 'Customer') {
      // Customer
      this.showCustomer = true;
      this.showDownloadBtn = true;
    } else {
      this.showCustomer = false;
      this.showDownloadBtn = false;
      this.tatForm.controls.ddlCustomer.reset();
    }
  }

  downloadFormatFile() {
    try {
      const fileDomainURL = this.utilities.getS3DownloadURL();
      let fileName = '';
      let downloadFileURL = '';
      const selectedTATType: any = this.tatForm.get('ddlTatType').value;
      const selectedTATCategory = this.tatForm.get('ddlContractType').value;
      if (selectedTATType) {
        let filePath = '';
        if (selectedTATType === 1) {
          filePath = this.tatTypeList.filter(x => x.id === selectedTATType)[0]?.tatfilepath;
        } else if (selectedTATType === 2) {
          filePath = this.tatTypeList.filter(x => x.id === selectedTATType)[0]?.tatfilepath;
        } else if (selectedTATType === 3) {
          // contract
          filePath = this.contractTypeList.filter(x => x.id === selectedTATCategory)[0]?.tatfilepath;
        }

        if (filePath) {
          fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
        }
        downloadFileURL = `${fileDomainURL}${filePath}`;

      } else {

      }

      // console.log('downloadFileURL: ', downloadFileURL);
      // const link = document.createElement('a');
      // link.setAttribute('target', '_blank');
      // link.setAttribute('href', downloadFileURL);
      // link.setAttribute('download', downloadFileURL);
      // document.body.appendChild(link);
      // link.click();
      // link.remove();

      saveAs(downloadFileURL, fileName);

    } catch (e) {
      console.log(e);
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  //to upload data to into DB
  uploadTat() {
    let interval: any;
    let timeout: any;
    this.isFormSubmitted = true;
    try {
      if (this.tatForm.valid) {
        // upload file to server
        // console.log(this.selectedFile);
        if (this.selectedFile) {
          this.showProgressBar = true;
          this.progress = 0;
          interval = setInterval(() => {
            if (this.progress < 99) {
              this.progress += 1;
            }
          }, 100);
          timeout = setTimeout(() => {
            if (this.progress >= 99 && this.progress < 100) {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
              this.showProgressBar = false;
              clearInterval(interval);
            }
          }, 5000);
          let isTATPeriodNotValid = false;
          this.ngxLoaderService.start();
          const reqObj = {
            id: this.tatId,
            fileid: null,
            tattype: this.tatTypeList.find(x => x.id === this.tatForm.controls.ddlTatType.value).tattype,
            tatcontracttype: this.contractTypeList.find(x => x.id === this.tatForm.controls.ddlContractType.value)?.tatcategory || null,
            fromdate: this.tatForm.controls.txtFromDate.value,
            todate: this.tatForm.controls.txtToDate.value,
            customerid: this.tatForm.controls.ddlCustomer.value,
            generatedfromid: this.selectedSCId
          }
          // lets check selected period validity before upload
          this.tatService.CheckTATPeriod(reqObj).subscribe(res => {
            try {
              if (res && res.success) {
                isTATPeriodNotValid = res.data?.err_msg;
                if (isTATPeriodNotValid) {
                  this.ngxLoaderService.stop();
                  clearInterval(interval);
                  clearTimeout(timeout);
                  setTimeout(() => {
                    this.showProgressBar = false;
                  }, 1000);
                  this.isFormSubmitted = false;
                  this.appCoreService.showMessage(res.message, 'Error', 'error')
                } else {
                  let requestObj = {
                    name: this.selectedFile.name,
                    fileType: this.selectedFile.type,
                    category: 'selectedUploadTypeText'
                  };
                  // get signed url and upload file
                  this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                    try {
                      if (res && res.success) {
                        const signedUrl = res.data.uploadURL;
                        const fileId = res.data.fileId;
                        reqObj.fileid = res.data.fileId;
                        if (signedUrl) {
                          let headers: HttpHeaders = new HttpHeaders({
                            "Content-Type": requestObj.fileType
                          });

                          this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                            if (f === null) {
                              this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                if (res && res.success) {
                                  (document.getElementById('importtat') as HTMLInputElement).value = '';
                                  const isDataUploaded = this.processTATCharges(reqObj);
                                  this.progress = isDataUploaded ? 100 : 20;
                                  clearInterval(interval);
                                  clearTimeout(timeout);
                                  setTimeout(() => {
                                    this.showProgressBar = false;
                                  }, 1000);
                                  this.ngxLoaderService.stop();
                                }
                              });
                            }
                          });
                        }
                      }
                    }
                    catch (error) {
                      console.error(error);
                    }
                  });
                }
              }
            }
            catch (error) {
              console.error(error);
              this.ngxLoaderService.stop();
            }
          });
        } else {
          console.log('No file selected');
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  processTATCharges(uploadData): boolean {
    try {
      this.tatService.UploadTAT(uploadData).subscribe(res => {
        if (res) {
          if (res.success) {
            this.successDialog("Record Updated successfully");
            return true;
          }
          if (!res.success) {
            this.ngxLoaderService.stop();
            this.warningExcelDialog(res.message, res?.data);
            return false;
          }
        }
      });
    } catch (e) {
      return false;
    }
  }

  bindTATInfoById(id: any) {
    this.tatService.GetTATInfoById(id).subscribe(res => {
      try {
        this.ngxLoaderService.start();
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataTATInfo = res.data;
        }
      } catch (error) {
        this.ngxLoaderService.stop();
        console.error(error);
      }
    })
  }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editPeriodAction(cell: any) {
    // console.log('TATperiod',cell.id);
    try {
      this.tatService.GetTATById({ id: cell.id, scid: this.selectedSCId }).subscribe(res => {
        try {
          if (res && res.data) {
            this.ngxLoaderService.stop();
            const resData = res.data[0];
            this.tatId = resData.id;
            this.periodData = resData;
            this.openPeriodModel(this.periodData);
          } else {
            this.ngxLoaderService.stop();
          }
        } catch (error) {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
    }
  }

  editAction(cell: any) {
    try {
      if (cell) {
        // console.log('TAT')
        //find the cell in rowData List
        this.detailData = this.rowDataTATInfo.find(item => item.id === cell.id);
        this.openDetailModel(this.detailData);
      }
    } catch (e) {
      console.error(e);
    }

  }
  viewAction(cell: any) {
    if (cell) {
      this.tatId = cell.id;
      this.bindTATInfoByTATId(this.tatId);
    }
  }

  async deletePeriodAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.tatService.DeleteTATById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.getAllTAT();
              this.rowDataTATInfo = [];
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  async deleteAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.tatService.DeleteTATInfoById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.bindTATInfoByTATId(this.tatId);
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }


  async openErrorDialog(msg: string) {
    const result = await Swal.fire({
      titleText: 'Error',
      html: msg,
      icon: 'error',
      // confirmButtonText: 'Yes',
      // showDenyButton: true,
      // denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });

    if (result.isConfirmed) {
      return false;
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      this.getAllTAT();
      this.isFormSubmitted = false;
      this.tatForm.reset();
      this.tatForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.tatForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  resetForm() {
    this.isFormSubmitted = false;
    this.showContract = false;
    this.tatForm.reset();
    this.tatForm.get('txtFromDate').setValue(this.utilities.formatDate().dateString)
    this.tatForm.get('txtToDate').setValue(this.utilities.formatDate().dateString)
    this.onChangeTatType();
    this.onChangeContractType();
  }

  async warningExcelDialog(msg: any, data: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      confirmButtonText: confirmText,
      showCloseButton: true,
      showConfirmButton: isHtml,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (res.isConfirmed) {
      this.excelService.exportAsExcelFile(data, "Tat_Errors_Import");
    }
  }
}